import { DataType } from '@pressreader/feed-types';

import { CollectionPagesFeedItemData } from './collection.pages.data';
import { CollectionType } from './collection.type';

export interface IUserCollection {
    id: string;
    displayName: string;
    name: string; // For backward compatibility
    slug: string;
    isPublic: boolean;
    type: CollectionType | undefined;
    contentCount?: number;
    isDeleteDisabled: boolean;
}

export interface CollectionFeedItem<T extends DataType> {
    id: string;
    type: T;
    isFeatured: boolean;
    data?: unknown;
}
export interface CollectionArticleFeedItem extends CollectionFeedItem<DataType.article> {
    data: null;
}
export interface CollectionPagesFeedItem extends CollectionFeedItem<DataType.bookmarkPages> {
    data: CollectionPagesFeedItemData;
}
export type AnyCollectionFeedItem = CollectionArticleFeedItem | CollectionPagesFeedItem;

export function isCollectionArticleFeedItem(item: AnyCollectionFeedItem): item is CollectionArticleFeedItem {
    return item.type === DataType.article;
}

export function isCollectionPagesFeedItem(item: AnyCollectionFeedItem): item is CollectionPagesFeedItem {
    return item.type === DataType.bookmarkPages;
}

export const allCollectionId = 'all';
export const channelCollectionId = 'channel';
export const readLaterCollectionId = 'readlater';

export const defaultCollectionId = allCollectionId;
